import { Route, Routes } from "react-router-dom";
import Auth from "../Pages/Auth";
import PatientDashboard from "../Pages/Patient/PatientDashboard";
import DoctorDashboard from "../Pages/Doctor/DoctorDashboard";
import AdminDashboard from "../Pages/Admin/AdminDashboard";
import MyAppointment from "../Pages/Patient/MyAppointment";
import MyAppointments from "../Pages/Patient/MyAppointments";
import PatientProfile from "../Pages/Patient/PatientProfile";
import { Privateroutes } from "./Privateroutes";
import Visible from "../Pages/Visible";
import ForgotPassword from "../Pages/Forgotpassword";
import ResetPassword from "../Pages/ResetPassword";
import Reviews from "../Pages/Reviews";
import Shopfront from "../Pages/Shop/Shopfront";
import ProductDetail from "../Pages/Shop/ProductDetail";
import CheckoutFlow from "../Pages/Shop/CheckoutFlow";
import PatientOrders from "../Pages/Patient/PatientOrders";

function AllRoutes() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Visible />} />
        <Route path="/register" element={<Auth initialMode="register" />} />
        <Route path="/login" element={<Auth initialMode="login" />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/shop" element={<Privateroutes><Shopfront /></Privateroutes>} />
        <Route path="/shop/product/:id" element={<Privateroutes><ProductDetail /></Privateroutes>} />
        <Route path="/shop/checkout" element={<Privateroutes><CheckoutFlow /></Privateroutes>} />
        <Route path="/patient-dashboard" element={<Privateroutes><PatientDashboard /></Privateroutes>} />
        <Route path="/patient-orders" element={<Privateroutes><PatientOrders /></Privateroutes>} />
        <Route path="/doctor-dashboard" element={<Privateroutes><DoctorDashboard /></Privateroutes>} />
        <Route path="/doctor/dashboard" element={<Privateroutes><DoctorDashboard /></Privateroutes>} />
        <Route path="/doctor/slots" element={<Privateroutes><DoctorDashboard /></Privateroutes>} />
        <Route path="/doctor/messages" element={<Privateroutes><DoctorDashboard /></Privateroutes>} />
        <Route path="/doctor/blogs" element={<Privateroutes><DoctorDashboard /></Privateroutes>} />
        <Route path="/doctor/profile" element={<Privateroutes><DoctorDashboard /></Privateroutes>} />
        <Route path="/admin-dashboard" element={<Privateroutes><AdminDashboard /></Privateroutes>} />
        <Route path="/myappointment" element={<Privateroutes><MyAppointments /></Privateroutes>} />
        <Route path="/patient-profile" element={<Privateroutes><PatientProfile /></Privateroutes>} />
      </Routes>
    </div>
  );
}

export default AllRoutes;
